<template>
  <div class="describe-yourslef-div container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">
                  Describe Yourself ( Minimum 3 )
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DescribeWords
        is_describe_yourself="true"
        title="Pick 3 words to describe yourself best."
        :options="options"
        client_name="MID"
      />
    </div>
  </div>
</template>

<script>
import DescribeWords from "../single_question/word.vue";
import $, { event } from "jquery";
import axios from "axios";

export default {
  name: "DescribeYourself",
  components: { DescribeWords },
  data() {
    return {
      options: [
        { id: 1, name: "Trusting" },
        { id: 2, name: "Witty" },
        { id: 3, name: "Self-critical" },
        { id: 4, name: "Sympathetic" },
        { id: 5, name: "Responsible" },
        { id: 6, name: "Organized" },
        { id: 7, name: "Loyal" },
        { id: 8, name: "Kind" },
        { id: 9, name: "Humerous" },
        { id: 10, name: "Passionate" },
      ],
      
      client_name:"MID"
    };
  },
  mounted(){
    this.getDescribeWords()
  
  },
  methods:{
    getDescribeWords(){
        axios
        .get("social/admin/words", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.data);
          this.options = response.data.data
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/interests_describe/DescribeYourself.vue